@if (loading || products.length) {
  <section class="product-rail" [attr.aria-label]="title || null">
    @if (title) {
      <div class="rail-header">
        <h2><i class="fas" [ngClass]="icon" aria-hidden="true"></i> {{ title }}</h2>
      </div>
    }

    <div class="rail-scroll-container">
      <button type="button" class="scroll-arrow left" (click)="scroll('left')" aria-label="Scroll left" tabindex="-1">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>

      <div class="rail-scroll-row" #scrollRow>
        @if (!loading) {
          @for (product of products; track product.id) {
            <app-product-card class="rail-item" [product]="product" [compact]="true"></app-product-card>
          }
        } @else {
          @for (s of skeletons; track $index) {
            <app-product-rail-skeleton class="rail-item"></app-product-rail-skeleton>
          }
        }
      </div>

      <button type="button" class="scroll-arrow right" (click)="scroll('right')" aria-label="Scroll right" tabindex="-1">
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </section>
}
